import { Component, Output, EventEmitter, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalConfirmActionComponent } from 'src/app/app-layout/modal-confirm-action/modal-confirm-action.component';

@Component({
  selector: 'apc-mono-action-buttons',
  templateUrl: './mono-actions.component.html',
  styleUrls: ['../action-buttons.component.scss'],
})
export class SemiActionsComponent {
  @Output() editEvent = new EventEmitter<boolean>(false);
  @Output() saveEvent = new EventEmitter<boolean>(false);
  @Output() cancelEvent = new EventEmitter<boolean>(false);
  @Output() deleteEvent = new EventEmitter<boolean>(false);
  @Output() preDeleteEvent = new EventEmitter<boolean>(false);
  @Input() disableSave: boolean = false;
  @Input() hideExtraFields: boolean = false;
  @Input() personaSubsectionIdentifier: string;
  @Input() personaIdentifier: string;
  @Input() deleteItem: boolean = false;
  @Input() form: any;
  @Input() deleteText: string = "Are you sure to delete this item?";
  @Input() disableDeleteConfirmButton: boolean = false;
  @Input() isQuestion: boolean = true;

  @Input() edit: boolean = false;

  constructor(private modalService: NgbModal) { }



  editForm(e?: any) {
    var headerHeight = document.getElementById("top-header") && document.getElementById("top-header").clientHeight;
    var navHeight = document.getElementById("navbar-big") && document.getElementById("navbar-big").clientHeight;
    var heightToScroll: any = headerHeight + navHeight + 46;
    this.edit = !this.edit;
    setTimeout(() => {
      e && window.scrollTo({ top: (e.pageY - heightToScroll), behavior: 'smooth' });
    }, 100);
    this.editEvent.emit(this.edit);
  }

  saveForm() {
    this.saveEvent.emit(true);
  }

  cancelForm() {
    if (this.form?.dirty) {
      const modalRef = this.modalService.open(ModalConfirmActionComponent);
      modalRef.componentInstance.message = 'modals.message.undoChangesMessage';
      modalRef.result.then(result => {
        if (result)
          this.confirmCancelForm();
      });
    }
    else
      this.confirmCancelForm();
  }

  confirmCancelForm() {
    this.cancelEvent.emit(true);
    this.editForm();
  }

  delete() {
    this.deleteEvent.emit(true);
  }

  predelete() {
    this.preDeleteEvent.emit(true);
  }
}
